import { render, staticRenderFns } from "./PhoneField.vue?vue&type=template&id=07d3c859&"
import script from "./PhoneField.vue?vue&type=script&lang=js&"
export * from "./PhoneField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports